import { Button, message, Progress,Input,Carousel ,Image} from "ant-design-vue";

export default [Button, message, Progress,Input,Carousel,Image];
